import React from 'react';

// SOFTCAT 디자인 시스템 페이지네이션 (sc-pagination)
const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    if (!totalPages || totalPages <= 1) return null;

    // 현재 페이지 주변 최대 5개를 노출한다
    const getPageNumbers = () => {
        const pageNumbers = [];
        let startPage = Math.max(0, currentPage - 2);
        let endPage = Math.min(totalPages - 1, currentPage + 2);

        if (endPage - startPage < 4) {
            if (startPage === 0) {
                endPage = Math.min(4, totalPages - 1);
            } else if (endPage === totalPages - 1) {
                startPage = Math.max(0, totalPages - 5);
            }
        }

        for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
        return pageNumbers;
    };

    const isFirst = currentPage === 0;
    const isLast = currentPage === totalPages - 1;

    return (
        <nav className="sc-pagination" aria-label="페이지 이동">
            <button className="sc-page" onClick={() => onPageChange(0)} disabled={isFirst} aria-label="첫 페이지">&laquo;</button>
            <button className="sc-page" onClick={() => onPageChange(currentPage - 1)} disabled={isFirst} aria-label="이전 페이지">&lt;</button>

            {getPageNumbers().map((number) => (
                <button
                    key={number}
                    className={`sc-page${currentPage === number ? ' sc-page--current' : ''}`}
                    onClick={() => onPageChange(number)}
                    aria-current={currentPage === number ? 'page' : undefined}
                >
                    {number + 1}
                </button>
            ))}

            <button className="sc-page" onClick={() => onPageChange(currentPage + 1)} disabled={isLast} aria-label="다음 페이지">&gt;</button>
            <button className="sc-page" onClick={() => onPageChange(totalPages - 1)} disabled={isLast} aria-label="마지막 페이지">&raquo;</button>
        </nav>
    );
};

export default Pagination;
